export default __webpack_public_path__ + "static/11-1--092f01579bfaff8592c6d5d248d8b0de.png";